import { useState } from 'react';
import type { Contact } from '../../../types/contact';

const MAX_CONTACTS = 5;

interface UseContactMultiSelectionParams {
  contacts: Contact[];
  initialContacts?: Contact[];
}

export function useContactMultiSelection({ contacts, initialContacts }: UseContactMultiSelectionParams) {
  const [selectedContactsMap, setSelectedContactsMap] = useState<Map<number, Contact>>(() => {
    if (initialContacts && initialContacts.length > 0) {
      return new Map(initialContacts.map((c) => [c.id, c]));
    }
    return new Map();
  });

  const handleToggleContactSelection = (contactId: number) => {
    const contact = contacts.find((c) => c.id === contactId);
    if (!contact) return;

    setSelectedContactsMap((prev) => {
      const newMap = new Map(prev);
      if (newMap.has(contactId)) {
        newMap.delete(contactId);
      } else {
        if (newMap.size >= MAX_CONTACTS) {
          alert(`Ви можете вибрати максимум ${MAX_CONTACTS} контактів`);
          return prev;
        }
        newMap.set(contactId, contact);
      }
      return newMap;
    });
  };

  return {
    selectedContactsMap,
    handleToggleContactSelection,
  };
}
